import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SectionHeader } from "./Top3";
import EditableText from "./EditableText";
import { toast } from "sonner";

const notifyTodoist = (res) => {
  if (!res?._todoist) return;
  if (res._todoist === "created") toast("Created in Todoist");
  else if (res._todoist === "updated") toast("Updated in Todoist");
  else if (res._todoist === "sync_failed") toast("Todoist sync failed", { description: "Local change kept." });
};

const BusinessPulse = () => {
  const [items, setItems] = useState([]);
  const load = () => api.pulse().then(setItems);
  useEffect(() => { load(); }, []);

  return (
    <section data-testid="pulse-section">
      <SectionHeader
        code="05" label="BUSINESS PULSE"
        caption="Attention across each front — no dashboards, just what matters."
        labelKey="section.pulse.label"
        captionKey="section.pulse.caption"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {items.map((b, idx) => (
          <div key={b.id} className="op-panel p-5 relative overflow-hidden" data-testid={`pulse-${b.business}`}>
            <div className="op-ghost-number text-[64px] absolute -right-1 -top-3">
              {String(idx + 1).padStart(2, "0")}
            </div>
            <div className="relative z-10">
              <EditableText
                value={b.business}
                onSave={async (v) => { await api.patchPulse(b.id, { business: v.toUpperCase() }); load(); }}
                className="op-tag mb-3 block"
                testid={`pulse-business-${b.id}`}
              />
              <div className="mb-4">
                <div className="op-tag text-[#00E5FF] mb-1">PRIORITY</div>
                <EditableText
                  value={b.priority || ""}
                  onSave={async (v) => { const res = await api.patchPulse(b.id, { priority: v }); notifyTodoist(res); load(); }}
                  className="text-white text-sm leading-snug block"
                  multiline
                  emptyPlaceholder="—"
                  testid={`pulse-priority-${b.id}`}
                />
              </div>
              <div className="mb-4">
                <div className="op-tag mb-1">WAITING ON</div>
                <EditableText
                  value={b.waiting_on || ""}
                  onSave={async (v) => { const res = await api.patchPulse(b.id, { waiting_on: v }); notifyTodoist(res); load(); }}
                  className="text-[#A0A5B5] text-sm leading-snug block"
                  multiline
                  emptyPlaceholder="—"
                  testid={`pulse-waiting-${b.id}`}
                />
              </div>
              <div>
                <div className="op-tag mb-1">NEXT ACTION</div>
                <EditableText
                  value={b.next_action || ""}
                  onSave={async (v) => { const res = await api.patchPulse(b.id, { next_action: v }); notifyTodoist(res); load(); }}
                  className="text-white text-sm leading-snug block"
                  multiline
                  emptyPlaceholder="—"
                  testid={`pulse-next-${b.id}`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BusinessPulse;
